import Chip from '@/components/chip';
import Icon from '@/components/icon';
import { UiOption } from '@/lib/helpers';
import { Box, Stack } from '@mui/material';

export const getFormattedUiOptions = (options: UiOption[]) => {
  return options.map(({ label, value, disabled, meta, description }) => {
    if (meta?.blockedByOrgPolicy) {
      label = (
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Box>{label}</Box>
          <Icon name="lock" size="small" />
        </Stack>
      );
    }

    if (meta?.orgPolicyLevel || meta?.isDefaultPolicy) {
      label = (
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Box>{label}</Box>
          <Chip label="Default Policy" size="x-small" />
        </Stack>
      );
    } else if (meta?.recommended) {
      label = (
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Box>{label}</Box>
          <Chip label="Recommended" size="x-small" />
        </Stack>
      );
    }

    if (meta?.comingSoon) {
      label = (
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Box>{label}</Box>
          <Chip label="Coming Soon" size="x-small" />
        </Stack>
      );
    }

    return {
      label,
      value,
      disabled,
      meta,
      description,
    } as UiOption;
  });
};
